import React, { useRef } from 'react'
import SbEditable from 'storyblok-react'
import FluidImage from 'src/utils/FluidImage'
import InView from 'src/utils/InView';

const FullWidthImage = ({ blok }) => {
    const ref = useRef()
    const isVisible = InView(ref, true)

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div 
                className={`relative bg-white py-16 lg:py-32 px-6 duration-500 opacity-0 translate-y-10 ${isVisible && 'opacity-100 !translate-y-0'}`}
                ref={ref}
            >
                <div className="relative max-w-7xl mx-auto">
                    <FluidImage className="rounded-xl block w-full h-full object-cover shadow-xl" image={blok.image} />
                </div>
            </div>
        </SbEditable>
    )
}

export default FullWidthImage